import React, { FC } from 'react';
import { FinancialBreakdownData } from './types';

interface FinancialBreakdownProps {
  data?: FinancialBreakdownData | null;
}

const fmt = (n: number) =>
  `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const FinancialBreakdown: FC<FinancialBreakdownProps> = ({ data }) => {
  if (!data) return null;

  const marginPct = data.total_raised > 0 ? Math.round((data.total_profit / data.total_raised) * 100) : 0;
  const profitBarPct = Math.min(marginPct, 100);

  const marginColor = marginPct >= 20 ? '#15803d' : marginPct >= 10 ? '#a16207' : '#64748b';
  const marginBg    = marginPct >= 20 ? '#dcfce7' : marginPct >= 10 ? '#fef9c3' : '#f1f5f9';

  return (
    <div className="bg-white rounded-3 shadow-sm p-3 h-100" style={{ border: '1px solid #f0f0f0' }}>
      <h6 className="fw-bold mb-3" style={{ color: '#1a1a2e', fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        Financials
      </h6>

      <div className="d-flex flex-column gap-3">
        <div>
          <div className="d-flex justify-content-between align-items-baseline mb-2">
            <span className="text-muted" style={{ fontSize: 12 }}>Total Raised</span>
            <span className="fw-bold" style={{ fontSize: 16, color: '#1a1a2e' }}>{fmt(data.total_raised)}</span>
          </div>
          <div className="rounded-pill overflow-hidden" style={{ height: 5, background: '#f1f5f9' }}>
            <div style={{ height: '100%', width: '100%', background: '#163172', borderRadius: 4 }} />
          </div>
        </div>

        <div>
          <div className="d-flex justify-content-between align-items-baseline mb-2">
            <span className="text-muted" style={{ fontSize: 12 }}>Organization Profit</span>
            <span className="fw-bold" style={{ fontSize: 16, color: '#059669' }}>{fmt(data.total_profit)}</span>
          </div>
          <div className="rounded-pill overflow-hidden" style={{ height: 5, background: '#f1f5f9' }}>
            <div style={{ height: '100%', width: `${profitBarPct}%`, background: '#059669', borderRadius: 4 }} />
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between pt-2" style={{ borderTop: '1px solid #fafafa' }}>
          <span className="text-muted" style={{ fontSize: 12 }}>Profit margin</span>
          <span
            className="badge rounded-pill fw-semibold"
            style={{ fontSize: 11, padding: '3px 9px', background: marginBg, color: marginColor }}
          >
            {marginPct}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default FinancialBreakdown;
